// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2qkLk","sendOtp":"AuthorizeToLogin_sendOtp__3Dc05"};